export default __webpack_public_path__ + "static/media/monitor.5984b536.svg";